module.exports = __webpack_public_path__ + "static/media/shutter.ce1581e5.mp3";